// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-logo {
  width: 109px;
  height: 74px;
  position: relative;
  left: 105px;
  top: -20px;
}

.reset-text {
  margin-bottom: 0px !important;
  font-size: 13px;
  font-weight: bold;
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/common/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AACJ;;AACA;EACI,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAEJ","sourcesContent":[".login-logo{\r\n    width: 109px;\r\n    height: 74px;\r\n    position: relative;\r\n    left: 105px;\r\n    top: -20px;\r\n}\r\n.reset-text{\r\n    margin-bottom: 0px !important;\r\n    font-size: 13px;\r\n    font-weight: bold;\r\n    margin-top: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
